/* eslint-disable react/prop-types */
import React from 'react';

import Container from '@zg-rentals/multibrand-ui/lib/Container';
import StyledContainer from '@zg-rentals/multibrand-ui/lib/StyledContainer';

import './style.scss';

function TermsStyleWrapper(props = {}) {
  const { children, cssClass = '' } = props;

  return (
    <StyledContainer className={`TermsPage__wrapper ${cssClass}`} backgroundColor="lightestGrey">
      <Container className="TermsPage__content">
        <StyledContainer
          className="TermsPage__content-area"
          backgroundColor="white"
          borderWidth="thin"
          borderFull
          borderRounded
        >
          {children}
        </StyledContainer>
      </Container>
    </StyledContainer>
  );
}

export default TermsStyleWrapper;
